import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      columnGap: theme.spacing(0.5),
    },

    icon: {
      fontSize: theme.typography.pxToRem(20),
      borderRadius: 2,
    },
    iconSvgString: {
      '& > svg': {
        fontSize: theme.typography.pxToRem(20),
        width: '1em',
        height: '1em',
      },
    },
    label: {
      width: '100%',
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(19),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'start',
    },
  }),
  { name: 'GenerationToolItem' }
);
